import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  constructor() { }
  // private selectedMenuSubject = new BehaviorSubject<string>('Dashboard');
  // public selectedMenu$: Observable<string> = this.selectedMenuSubject.asObservable();

   private selectedMenuSource = new BehaviorSubject<string>(
    localStorage.getItem('selectedMenu') || 'Dashboard' // default if not set
  );

  selectedMenu$ = this.selectedMenuSource.asObservable();

  updateSelectedMenu(menu: string) {
    localStorage.setItem('selectedMenu', menu); // persist to localStorage
    this.selectedMenuSource.next(menu);
  }
}


  // updateSelectedMenu(menuName: string): void {
  //   this.selectedMenuSubject.next(menuName);
  // }

  // getCurrentMenu(): string {
  //   return this.selectedMenuSubject.value;
  // }
// }
